import { apiFetch } from './api';
import type { Battery, Device, VendorPrice } from '../types/models';

export async function getBattery(id: string): Promise<Battery> {
  const res = await apiFetch<{ battery: Battery }>(`/batteries/${id}`);
  return res.battery;
}

export async function getBatteryVendorPrices(batteryId: string): Promise<VendorPrice[]> {
  const res = await apiFetch<{ prices: VendorPrice[] }>(`/batteries/${batteryId}/vendor-prices`);
  return res.prices;
}

export async function compatibleDevices(batteryId: string): Promise<Device[]> {
  const res = await apiFetch<{ devices: Device[] }>(`/batteries/${batteryId}/devices`);
  return res.devices;
}
